<template>
  <div class="voucher-card">
    <div class="voucher-info">
      <div class="voucher-image">
        <div class="image-wrp">
          <div
            v-if="detail.isAdmin"
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <img
              src="@/assets/images/gear-icon.svg"
              alt="grear-icon"
              class="my-1 gear-icon"
            />
            <span>Shopee</span>
          </div>
          <div
            v-else
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <img
              src="@/assets/images/shop-icon.svg"
              alt="shop-icon"
              class="my-2 shop-icon"
            />
            <span>{{ $t("shop") }}</span>
          </div>
          <!-- <img :src="imageUrl" /> -->
        </div>
      </div>
      <div class="voucher-details w-100">
        <div class="pt-3 badge-voucher-wrp">
          <span class="badge-voucher">{{ detail.voucherName }}</span>
        </div>
        <div class="d-flex justify-content-between w-100">
          <div class="detail-wrp">
            <div class="discount">{{ detail.percentage }}% OFF</div>
            <div>
              Min.Spend {{ getCurrency(detail.minBasketPrice) }}, Capped at
              {{ getCurrency(detail.discountAmount) }}
            </div>
            <div class="validDate">
              Valid till: {{ detail.endAt | moment($formatDate) }}
            </div>
          </div>
          <div class="btn-wrp">
            <button class="btn  d-block text-left pr-0" @click="sendVoucher">
              <span class="btn-send">send</span>
            </button>
            <button class="btn pr-0" @click="gotoVoucher">
              <div class="btn-detail">{{ $t("detail") }}</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import getCurrencyByMode from "@/helpers/getCurrencyByMode";

export default {
  props: {
    detail: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      imageUrl: "https://cf.shopee.co.th/file/sg-11134201-7rdxg-mcagrnb0awt510"
    };
  },
  methods: {
    gotoVoucher() {
      var uri = `https://seller.th.shopee.cn/portal/marketing/vouchers/${this.detail.voucherId}`;
      window.open(uri, "_blank");
    },

    moment: function() {
      return moment();
    },
    sendVoucher() {
      this.$emit("showConfirmVoucherReply", this.detail);
    },
    getCurrency(amount) {
      const MODE = process.env.VUE_APP_MODE;
      return getCurrencyByMode(amount, MODE);
    }
  }
};
</script>

<style lang="scss" scoped>
.voucher-card {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  font-size: 12px;

  .voucher-info {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;

    .voucher-image {
      height: 100%;
      padding-right: 6px;
      .image-wrp {
        width: 5vw;
        height: 100%;
        flex-shrink: 0;
        overflow: hidden;

        .gear-icon {
          width: 35px;
          height: 35px;
        }

        .shop-icon {
          width: 30px;
          height: 30px;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .voucher-details {
      padding-left: 5px;
      border-left: 0.1px dashed #e4e4e4 !important;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .detail-wrp {
        padding: 0 0px 12px 12px;
      }
      .discount {
        color: #832abf;
        font-size: 15px;
        font-weight: 600;
      }

      .validDate {
        color: #707070;
      }

      .badge-voucher-wrp {
        padding-left: 10px;
        .badge-voucher {
          padding: 0px 10px;
          background-color: #f1f1f1;
          color: #2c3e50;
          word-break: break-all;
        }
      }
    }
  }
  .btn-wrp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    .btn-send {
      background-color: #832abf !important;
      border-color: #832abf;
      color: #fff;
      padding: 3px 10px;
      font-size: 12px;
      border-radius: 3px;
    }
    .btn-detail {
      color: #832abf;
      border: 1px solid #832abf;
      background-color: #fff;
      padding: 3px 10px;
      font-size: 12px;
      border-radius: 3px;
      display: ruby-text;
    }
  }
}
</style>
